module.exports = __webpack_public_path__ + "media/images/eye-icon-8e0eddea032a0084897777fc643569d7.svg";